export enum ViewMode {
    List = 1,
    Cards,
}

export enum LoadingStates{
    Success,
    Pending,
    Fail,
    Gone, // Ressource nicht länger verfügbar
    Initial,
    EmptyResult
}